import {
  SECTION_SELECTED_CONTROLLER
} from "../../Models/Common/local-storage-enum"
import {
  CLOSE_TO_DISPATCH,
  DISPATCHED,
  EXTRA_SERVICES,
  IN_PROGRESS,
  RECENTLY_ACTIVATED,
  SCHEDULED,
  MARKET_PLACE
} from "../../Models/Common/footer-bucket-enum"
import {
  UPDATE_FOOTER_COUNTERS_LOADING,
  UPDATE_FOOTER_COUNTERS_SUCCESS,
  UPDATE_FOOTER_COUNTERS_FAILED,
  RESET_SELECTED_SECTION
} from "../types"

const initialState = {
  loading: false,
  message: null,
  error: false,
  //inProgress
  inProgressActive: false,
  inProgressCounter: 0,
  //closeToDispatch
  closeToDispatchActive: false,
  closeToDispatchCounter: 0,
  //recentlyActivated
  recentlyActivatedActive: false,
  recentlyActivatedCounter: 0,
  //scheduled
  scheduledActive: false,
  scheduledCounter: 0,
  //dispatched
  dispatchedActive: false,
  dispatchedCounter: 0,
  //extraServices
  extraServicesActive: false,
  extraServicesCounter: 0,
  //marketPlace
  marketPlaceActive: false,
  marketPlaceCounter: 0,
  active: (typeof window !== "undefined" && sessionStorage.getItem(SECTION_SELECTED_CONTROLLER)) ? sessionStorage.getItem(SECTION_SELECTED_CONTROLLER) : IN_PROGRESS,
}

const setActiveBucket = (result, newCurrentSection) => {
  result.inProgressActive = newCurrentSection === IN_PROGRESS
  result.closeToDispatchActive = newCurrentSection === CLOSE_TO_DISPATCH
  result.recentlyActivatedActive = newCurrentSection === RECENTLY_ACTIVATED
  result.scheduledActive = newCurrentSection === SCHEDULED
  result.dispatchedActive = newCurrentSection === DISPATCHED
  result.extraServicesActive = newCurrentSection === EXTRA_SERVICES
  result.marketPlaceActive = newCurrentSection === MARKET_PLACE
  result.active = newCurrentSection
  return result
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_FOOTER_COUNTERS_LOADING:
      var result = {
        ...state,
        loading: true,
        error: false,
        message: null,
        inProgressCounter: 0,
        closeToDispatchCounter: 0,
        recentlyActivatedCounter: 0,
        scheduledCounter: 0,
        dispatchedCounter: 0,
        extraServicesCounter: 0,
        marketPlaceCounter: 0
      }
      return setActiveBucket(result, action.payload.newCurrentSection)

    case UPDATE_FOOTER_COUNTERS_FAILED:
      var result = {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        inProgressCounter: 0,
        closeToDispatchCounter: 0,
        recentlyActivatedCounter: 0,
        scheduledCounter: 0,
        dispatchedCounter: 0,
        extraServicesCounter: 0,
        marketPlaceCounter: 0
      }
      return setActiveBucket(result, action.payload.newCurrentSection)
    case UPDATE_FOOTER_COUNTERS_SUCCESS:
      var result = {
        ...state,
        loading: false,
        error: false,
        message: null,
        inProgressCounter: Math.floor(Math.random() * 50),
        closeToDispatchCounter: Math.floor(Math.random() * 50),
        recentlyActivatedCounter: Math.floor(Math.random() * 50),
        scheduledCounter: Math.floor(Math.random() * 50),
        dispatchedCounter: Math.floor(Math.random() * 50),
        extraServicesCounter: Math.floor(Math.random() * 50),
        marketPlaceCounter: Math.floor(Math.random()*50)
      }
      return setActiveBucket(result, action.payload.newCurrentSection)
    case RESET_SELECTED_SECTION:
      return {
        ...state,
        inProgressActive: true,
        closeToDispatchActive: false,
        recentlyActivatedActive: false,
        scheduledActive: false,
        dispatchedActive: false,
        extraServicesActive: false,
        marketPlaceActive: false,
        active: IN_PROGRESS
      }
    default:
      return state
  }
}
